export enum ExperienceLevel {
	ZeroToTwoYears = 0,
	ThreeToFiveYears = 1,
	SixToTenYears = 2,
	ElevenToTwentyYears = 3,
	TwentyPlusYears = 4
}

export const ExperienceLevelNames = {
	[ExperienceLevel.ZeroToTwoYears]: '0-2 Years of Experience',
	[ExperienceLevel.ThreeToFiveYears]: '3-5 Years of Experience',
	[ExperienceLevel.SixToTenYears]: '6-10 Years of Experience',
	[ExperienceLevel.ElevenToTwentyYears]: '11-20 Years of Experience',
	[ExperienceLevel.TwentyPlusYears]: '20+ Years of Experience',
};
